import { AgmInfoWindow } from '@agm/core';
import { Component, EventEmitter, HostListener, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { IMyOptions, ToastService } from 'ng-uikit-pro-standard';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { Subject } from 'rxjs';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { RecorridoDetalleService } from 'src/app/services/recorrido-detalle.service';
import { RuteadorService } from 'src/app/services/ruteador.service';
import { SignalRMessageService } from 'src/app/services/SignalRMessage.service';
import { SignalRService } from 'src/app/services/SignalRNegotiate.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { ModalOpcionesAsignacionComponent } from 'src/app/shared/components/modal-opciones-asignacion/modal-opciones-asignacion.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ENVIRONMENT_FUNCTIONS } from 'src/environments/environment';
import { RecorridoService } from '../../services/recorrido.service';
import { UnidadNegocioService } from '../../services/unidad-negocio.service';
import { DatesService } from '../../shared/services/dates.service';
import { SecurityService } from '../../shared/services/security.service';
import { RutService } from '../../shared/services/rut.service';
import { ModalAddEditRutasComponent } from './modal-add-edit-ruta/modal-add-edit-ruta.component';
import { RuteadorModalAsignarAutomaticaComponent } from './modal-asignar-automatica/modal-asignar-automatica.component';
import { RuteadorModalAsignarComponent } from './modal-asignar/modal-asignar.component';
import { RuteadorModalResultadoAsignacionComponent } from './modal-resultado-asignacion/modal-resultado-asignacion.component';
import { ModalRutasCamionComponent } from './modal-rutas-camion/modal-rutas-camion.component';
import { ModalRutasDivididasComponent } from './modal-rutas-divididas/modal-rutas-divididas.component';

@Component({
  selector: 'app-ruteador',
  templateUrl: './ruteador.component.html',
  styleUrls: ['./ruteador.component.scss'],
  providers: [SecurityService],
})
export class RuteadorComponent implements OnInit {
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;
  @ViewChild(ModalOpcionesAsignacionComponent, { static: true }) modalOpcionesAgsinacion: ModalOpcionesAsignacionComponent;
  @ViewChild(RuteadorModalAsignarComponent, { static: true }) modalAsignarCamion: RuteadorModalAsignarComponent;
  @ViewChild(RuteadorModalAsignarAutomaticaComponent, { static: true }) modalAsignarAutomaticaCamion: RuteadorModalAsignarAutomaticaComponent;
  @ViewChild(RuteadorModalResultadoAsignacionComponent, { static: true }) resultadoAsignacionModal: RuteadorModalResultadoAsignacionComponent;
  @ViewChild(ModalAddEditRutasComponent, { static: true }) verAddEditRutasModal: ModalAddEditRutasComponent;
  @ViewChild(ModalRutasCamionComponent, { static: true }) verRutasCamionModal: ModalRutasCamionComponent;
  @ViewChild(ModalRutasDivididasComponent, { static: true }) verRutasDivididasModal: ModalRutasDivididasComponent;
  @ViewChild('verDetalleCamionChofer', { static: true }) verDetalleCamionChoferModal: ModalDirective;
  @ViewChild('asignarCamionRutas', { static: true }) asignarCamionRutasModal: ModalDirective;
  @ViewChildren(AgmInfoWindow) infoWindows: QueryList<AgmInfoWindow>;


  eventsSubject: Subject<void> = new Subject<void>();

  formFiltrosDocumentos: FormGroup;

  //Paginacion
  paginationContextDetalles: PaginationContext = new PaginationContext();

  //Listado
  listadoCamionChofer: Array<any> = [];
  listaDocumentosRecorridos: any;
  listdocumentRec: Array<any> = [];
  listdocumentRecSelect: Array<any> = [];
  listdocumentRecAll: Array<any> = [];
  listaDocumentosReasignar: any;
  documentosRecorridos: Array<any> = [];
  documentosRecorridosSeleccionados: Array<any> = [];
  listadoSeleccionadosAsignados: Array<any> = [];
  listadoSeleccionadosLiberar: Array<any> = [];
  listadoSeleccionadosAsignadosTotales: Array<any> = null;
  documentosSeleccionadosAsignacion: Array<any> = [];
  listadoDetalleCamionChofer: Array<any> = [];
  listadoDetalleCamionChoferAll: Array<any> = null;
  recorridoDetalleSeleccionado: any = null;
  listadoDetalleDocumentos: Array<any> = [];
  beaches: Array<any> = [];
  beachesAll: Array<any> = [];
  beachesSeleccionados: Array<any> = [];
  beachesAsignadoSeleccionados: Array<any> = [];
  beaches_rutas = [];
  listaDocumentoAsignado: Array<any> = [];
  listaDocumentoAsignadoSelect: Array<any> = [];
  listaDocumentoAsignadoAll: Array<any> = [];

  // Configuración del mapa por defecto (Chile)
  defaultLatitude = -33.4489;  // Santiago, Chile
  defaultLongitude = -70.6693; // Santiago, Chile
  defaultZoom = 6;             // Zoom para mostrar Chile completo

  // Límite de waypoints de Google Maps Directions API
  private readonly GOOGLE_MAPS_WAYPOINT_LIMIT = 25;

  //Options
  optionsEstado: Array<any> = [];
  optionsEstadoDetalle: Array<any> = [];
  optionsComuna: Array<any> = [];
  optionsTerritorios: Array<any> = [];
  optionsVendedor: Array<any> = [];
  optionsUnidadesDeNegocio: unidad_negocio[] = [];

  //Variables
  public rutEmpresa: number;
  public rutUsuario: number;
  public sucursalCodigo: number;
  public latitudEmpresa;
  public longitudEmpresa;
  sumTotalCajas: number = 0;
  sumTotalUnidad: number = 0;
  sumTotalPeso: number = 0;
  sumTotalVolumen: number = 0;
  sumTotalMonto: number = 0;
  sumTotalDocumentos: number = 0;
  sumUnidadSelect: number = 0;
  sumCajasSelect: number = 0;
  sumPesoSelect: number = 0;
  sumMontoSelect: number = 0;
  sumVolumenSelect: number = 0;
  areSelected: boolean;
  CheckBoxAllValue: boolean = false;
  checkAllRecorrido: boolean = false;
  loadingCamion: boolean = false;
  public permiteUnidadNegocio: boolean = false;
  private isCheckingUnidadNegocio: boolean = true;
  total_documentos: any;
  documentos_entregados: any;
  documentos_pendientes: any;
  numeros_clientes: any;
  loading: boolean;
  loadingDetalles: boolean = false;
  loadingPdf: boolean = false;
  messageLoading: string = '';
  loadingBusqueda: boolean = false; // Para el indicador de búsqueda


  tittle: string;
  message: string;
  public drawingManager: any;
  globalMap: any;
  resumen_totales: any;
  polygon: google.maps.Polygon;
  totalesModalRecorrido: any;
  previous_info_window: AgmInfoWindow = null;

  //Oculta elementos del mapa
  public customStyle = [
    {
      featureType: 'poi.medical', //Hospitales y Clinicas
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.business', //Negocios
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.park', //Parques
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.sports_complex', //Complejos Deportivos
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.school', //Escuelas
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.attraction', //Sitios Turisticos y Atrasiones
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.place_of_worship', //Monasterios Iglesias
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.government', //Centrol Gubernamentales
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ];

  // Utils
  private log: any;

  constructor(
    private datesService: DatesService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private ruteadorService: RuteadorService,
    private parametroEmpresaService: ParametroEmpresaService,
    private unidadNegocioService: UnidadNegocioService,
    private formValidatorsService: FormValidatorsService,
    private toastService: ToastService,
    private recorridoService: RecorridoService,
    private recorridoDetalleService: RecorridoDetalleService,
    private fileDownloadService: FileDownloadService,
    private signalRMessageService: SignalRMessageService,
    private signalRService: SignalRService,
    private rutService: RutService
  ) {
    this.log = this.clog.log('RUTEADOR AUTOMATICO');
    //this.infoWindow = new google.maps.InfoWindow();
  }

  get listadoCamionChoferSelectCount(): number {
    return this.listadoCamionChofer.filter((x) => x.seleccion).length;
  }

  ngOnInit() {
    this.createForm();
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.rutUsuario = this.accesolocalstorage.getRutUsuario();
    this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();
    this.latitudEmpresa = this.accesolocalstorage.getLatitudEmpresa();
    this.longitudEmpresa = this.accesolocalstorage.getLongitudEmpresa();
    this.paginationContextDetalles.RecordsByPage = 100;
    this.suscribeSignalRMessage();
    this.updateBloqueoProcesoSignalR();
    this.checkUnidadNegocio();
    this.loadInitialData();
  }

  suscribeSignalRMessage() {
    this.signalRService.init();
    this.signalRService.messages.subscribe((message) => {
      this.handleMessage(message);
    });
  }

  handleMessage(message: any) {
    const data = JSON.parse(message);
    console.log('message recibido', message, data);
    if (data && data.length > 0) {
      const tipo = data.tipo_notificacion_codigo;
      const categoria = data.categoria_modulo_codigo;
      const id = `${tipo}_${categoria}`;
      if (!sessionStorage.getItem(`processSignal${id}`)) {
        this.loadingPdf = false;
      }
    }
  }

  updateBloqueoProcesoSignalR() {
    const entidadRef = { tipo_notificacion_codigo: 7, categoria_modulo_codigo: 2 };
    const bloquearGeneracion = this.signalRMessageService.hasProcesoPendiente(entidadRef);
    if (bloquearGeneracion) {
      this.loadingPdf = true;
      this.messageLoading = 'Existe una generacion de PDFs en curso... Una vez generados se mostrarán en las notificaciones';
    }
  }

  loadInitialData() {
    if (this.isCheckingUnidadNegocio) return;
    if (this.permiteUnidadNegocio === true && (this.formFiltrosDocumentos.get('unidad_negocio_codigo').value == null || this.formFiltrosDocumentos.get('unidad_negocio_codigo').value == 0)) {
      return;
    }

    this.optionsEstado = [
      { value: '', label: 'Seleccionar Estado' },
      { value: '0', label: 'Todos' },
      { value: '1', label: 'Asignado' },
      { value: '2', label: 'No Asignado' },
    ];
    this.formFiltrosDocumentos.get('filtroEstado').setValue('0');

    this.optionsEstadoDetalle = [
      { value: '0', label: 'Todos los estados' },
      { value: '1', label: 'En carga' },
      { value: '2', label: 'Despachado' },
      { value: '3', label: 'Liquidado' },
    ];
    this.formFiltrosDocumentos.get('estadofiltroDetalleRecorrido').setValue('1');
    this.obtenerDocumentosRecorridoByFiltro();
    this.obtenerResumenDocumentos();
    //this.initDrawingManager(this.globalMap);
    this.opcionsPoligono();

    const fecha = this.formFiltrosDocumentos.get('fechafiltroDetalleRecorrido').value;
    const fechaHasta = this.formFiltrosDocumentos.get('fechafiltroDetalleRecorridoHasta').value;
    const estado = '1'; //Buscara todos los estados
    this.ObtenerCamiones(fecha, fechaHasta, estado);
  }

  checkUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(Number(this.rutEmpresa), ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteUnidadNegocio = respuesta.valor_bool;

      if (this.permiteUnidadNegocio) {
        this.loadUnidadNegocio();
      } else {
        this.isCheckingUnidadNegocio = false;
        this.loadInitialData();
      }
    });
  }

  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        tipo: 1,
      },
    };
    this.optionsUnidadesDeNegocio = [];
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsUnidadesDeNegocio = registros.map((unidad_negocio) => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre,
      }));
      this.AddUnidadDeNegocioValidators();
      this.isCheckingUnidadNegocio = false;
      this.loadInitialData();
    });
  }

  checkAllRecorridosChange({ checked }) {
    this.checkAllRecorrido = checked;
    this.listadoCamionChofer.forEach((cam) => {
      if (cam.codigo_estado != 4 && cam.total_documentos > 0) {
        cam.seleccion = checked;
      }
    });
  }

  checkRecorridoChange(index, { checked }) {
    this.listadoCamionChofer[index].seleccion = checked;
  }

  AddUnidadDeNegocioValidators() {
    this.formValidatorsService.selectFirstOrDefault(this.formFiltrosDocumentos.get('unidad_negocio_codigo'), this.optionsUnidadesDeNegocio);
    this.formFiltrosDocumentos.get('unidad_negocio_codigo').setValidators([Validators.required]);
    this.formFiltrosDocumentos.get('unidad_negocio_codigo').updateValueAndValidity();
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formFiltrosDocumentos = this.fb.group({
      filtroFechaDesde: [currentDate],
      filtroFechaHasta: [currentDate],
      fechafiltroDetalleRecorrido: [currentDate],
      fechafiltroDetalleRecorridoHasta: [currentDate],
      filtroEstado: [''],
      estadofiltroDetalleRecorrido: [''],
      filtroComuna: [''],
      filtroVendedor: [''],
      filtroTerritorio: [''],
      unidad_negocio_codigo: [null],
    });
  }

  obtenerDocumentosRecorridoByFiltro() {
    const { filtroEstado, filtroComuna, filtroVendedor, filtroTerritorio } = this.formFiltrosDocumentos.value;
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formFiltrosDocumentos.get('filtroFechaDesde').value,
      fechaHasta: this.formFiltrosDocumentos.get('filtroFechaHasta').value,
      estado: filtroEstado,
      rut_empresa: this.rutEmpresa,
      comuna_codigo: filtroComuna === '' || filtroComuna === null || filtroComuna === undefined ? [] : filtroComuna,
      vendedor_codigo: filtroVendedor === '' || filtroVendedor === null || filtroVendedor === undefined ? [] : filtroVendedor,
      territorio_codigo: filtroTerritorio === '' || filtroTerritorio === null || filtroTerritorio === undefined ? [] : filtroTerritorio,
    };

    this.ruteadorService.obtenerDocumentosbyFiltros(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        this.loadingBusqueda = false; // Desactivar loading en caso de error
        return;
      }
      const { registros } = respuesta;

      this.listaDocumentosRecorridos = registros;

      this.documentosRecorridos = [];
      this.documentosRecorridos = this.listaDocumentosRecorridos;

      //SUMATORIA PARA CALCULAR TOTALES (solo documentos no asignados)
      const documentosNoAsignados = this.listaDocumentosRecorridos.filter(doc => doc.folio_recorrido_Detalle === 0);

      this.resumen_totales = {
        monto_total_peso: _.sumBy(documentosNoAsignados, 'total_peso'),
        monto_total: _.sumBy(documentosNoAsignados, 'total_monto'),
        monto_total_volumen: _.sumBy(documentosNoAsignados, 'total_volumen'),
        monto_total_doc: documentosNoAsignados.length,
      };

      this.sumTotalPeso = Math.round(this.resumen_totales.monto_total_peso);
      this.sumTotalMonto = this.resumen_totales.monto_total;
      this.sumTotalVolumen = Number(this.resumen_totales.monto_total_volumen.toFixed(2));

      console.log(this.sumTotalVolumen);
      this.sumTotalDocumentos = this.resumen_totales.monto_total_doc;
      this.obtenerTotales(this.listaDocumentosRecorridos);

      // Puntos de Mapa
      this.beaches = [];
      let sel: any;
      let contador = 0;
      let direccion = 0;
      let documentos = [];
      this.listaDocumentosRecorridos.forEach((element) => {
        const colorcode = this.obtenerCodigoColor(element);

        sel = { value: element.codigo, label: element.nombre };

        contador = contador + 1;

        // Si la dirección cambia, reiniciar el contador de documentos y actualizar la dirección actual
        if (direccion !== element.direccion_codigo) {
          direccion = element.direccion_codigo;
          documentos = [];
        }

        // Agregar el folio actual al array de documentos
        documentos.push(element.folio);

        // Validar coordenadas antes de agregar al array
        const lat = parseFloat(element.latitud);
        const lng = parseFloat(element.longitud);

        if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
          this.beaches.push({
            cliente_proveedor_nombre: element.nombre_cliente,
            cliente_proveedor_rut: element.cliente_proveedor_rut,
            latitud: element.latitud,
            longitud: element.longitud,
            contador: contador,
            iconUrl: element.folio_recorrido_Detalle > 0 ? this.createCustomMarker(colorcode) : this.createCustomMarker('#666666'), //`https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|${colorcode.toUpperCase()}` : '',
            // label: {
            //   color: 'white',
            //   text: 'A',
            // },
            draggable: false,
            color: colorcode,
            recorrido_codigo: element.recorrido_codigo,
            info: {
              title: element.nombre_cliente,
              description: '',
              address: element.direccion_completa,
              comuna: element.comuna,
              nroFacturas: 0,
              tipo_dte_codigo: element.tipo_dte_codigo,
              documento: documentos.join(', '),
              caja: element.caja,
              unidad: element.fraccion,
              peso: element.total_peso,
              volumen: element.total_volumen,
              vendedor: element.vendedor,
            },
          });
        } else {
          console.warn(`Documento con coordenadas inválidas omitido: ${element.nombre_cliente} - lat=${element.latitud}, lng=${element.longitud}`);
        }
        direccion = element.direccion_codigo;
      });
      this.beachesAll = this.beaches;

      //Busca el resumen de recorridos
      const estado = '1'; // Buscara todos los estados
      this.formFiltrosDocumentos.get('fechafiltroDetalleRecorrido').setValue(this.formFiltrosDocumentos.get('filtroFechaDesde').value);
      this.formFiltrosDocumentos.get('fechafiltroDetalleRecorridoHasta').setValue(this.formFiltrosDocumentos.get('filtroFechaHasta').value);
      this.ObtenerCamiones(this.formFiltrosDocumentos.get('filtroFechaDesde').value, this.formFiltrosDocumentos.get('filtroFechaHasta').value, estado);

      //Filtro de Comunas de Documentos
      this.optionsComuna = [];
      let sel2: any;
      let listaComunaDocumentoDistinct = this.listaDocumentosRecorridos.filter((thing, i, arr) => arr.findIndex((t) => t.comuna === thing.comuna) === i);
      listaComunaDocumentoDistinct.forEach((element) => {
        sel2 = { value: element.comuna_codigo, label: element.comuna };
        this.optionsComuna.push(sel2);
      });

      // Filtro Vendedor Documento
      this.optionsVendedor = [];
      let sel3: any;
      let listaVendedorDocumentoDistinct = this.listaDocumentosRecorridos.filter((thing, i, arr) => arr.findIndex((t) => t.vendedor === thing.vendedor) === i);
      listaVendedorDocumentoDistinct.forEach((element) => {
        sel3 = { value: element.vendedor_codigo, label: element.vendedor };
        this.optionsVendedor.push(sel3);
      });

      // Filtro Territorio Documento
      this.optionsTerritorios = [];
      let sel4: any;
      let listaTerritorioDocumentoDistinct = this.listaDocumentosRecorridos.filter((thing, i, arr) => arr.findIndex((t) => t.territorio === thing.territorio) === i);
      listaTerritorioDocumentoDistinct.forEach((element) => {
        sel4 = { value: element.territorio_codigo, label: element.territorio };
        this.optionsTerritorios.push(sel4);
      });
      this.initDrawingManager(this.globalMap);

      // Desactivar indicador de carga cuando termine la búsqueda
      this.loadingBusqueda = false;
      console.log('✅ Búsqueda completada');
    });
  }

  obtenerTotales(lista) {
    // Filtrar solo documentos no asignados (folio_recorrido_Detalle === 0)
    const documentosNoAsignados = lista.filter(doc => doc.folio_recorrido_Detalle === 0);

    this.listaDocumentoAsignado = [];
    this.listaDocumentoAsignado = _.cloneDeep(documentosNoAsignados);
    this.listaDocumentoAsignado.forEach((mov) => {
      delete mov.__typename;
      delete mov.estado;
      delete mov.estado_cliente;
      delete mov.nombre_cliente;
      delete mov.total_monto;
      delete mov.total_unidad;
      delete mov.total_cantidad;
      delete mov.total_volumen;
      delete mov.total_peso;
      delete mov.fecha_emision;
      delete mov.folio_recorrido_Detalle;
      delete mov.additionalInfo;
      delete mov.comuna_codigo;
      delete mov.vendedor_codigo;
      delete mov.territorio_codigo;
      delete mov.numero_documento;
      delete mov.tipo_documento;
      delete mov.total_documentos;
      delete mov.peso;
      delete mov.volumen;
      delete mov.cajas;
      delete mov.comuna_despacho;
      delete mov.vendedor_nombre;
      delete mov.rutaArchivo;
      delete mov.fecha_emision_folio;
      delete mov.unidad;
      delete mov.prioridad;
    });
    const inputParams = {
      lista: this.listaDocumentoAsignado,
    };
    //this.log('TOTAL ASIGNACION', JSON.stringify(inputParams));
    this.ruteadorService.obtenerTotalesAsignacion(inputParams, ({ respuesta }) => {
      if (respuesta == null) {
        this.loadingDetalles = false;
        return;
      }

      //this.log('TOTAL ASIGNACION', JSON.stringify(respuesta));
      //const { respuesta } = respuesta;
      let listaDocAsignadoTotales = respuesta;

      this.sumTotalCajas = listaDocAsignadoTotales.total_cantidad;
      this.sumTotalUnidad = listaDocAsignadoTotales.total_unidad;

      this.totalesModalRecorrido = {
        cajas: listaDocAsignadoTotales.total_cantidad,
        unidad: listaDocAsignadoTotales.total_unidad,
      };
    });
  }

  obtenerTotalesSeleccionPoligono(beachesSeleccionados: any, listaDocumento: any) {
    this.beachesAsignadoSeleccionados = beachesSeleccionados;
    this.documentosSeleccionadosAsignacion = listaDocumento;

    this.listadoSeleccionadosAsignados = [];
    this.documentosSeleccionadosAsignacion.forEach((element1) => {
      this.beachesAsignadoSeleccionados.forEach((element2) => {
        if (element1.latitud.trim() === element2.latitud.trim()) {
          if (element1.folio_recorrido_Detalle === 0) {
            this.listadoSeleccionadosAsignados.push({
              tipo_dte_codigo: element1.tipo_dte_codigo,
              folio: element1.folio,
              fecha_emision: element1.fecha_emision,
              vendedor_codigo: element1.vendedor_codigo,
              vendedor: element1.vendedor,
              rut_emisor: element1.rut_emisor,
              ruta_codigo: element1.ruta_codigo,
              cliente_proveedor_rut: element1.cliente_proveedor_rut,
              nombre_cliente: element1.nombre_cliente,
              comuna: element1.comuna,
              total_monto: element1.total_monto,
              caja: element1.caja,
              fraccion: element1.fraccion,
              direccion_codigo: element1.direccion_codigo,
              estado_cliente: element1.estado_cliente,
              direccion_completa: element1.direccion_completa,
              total_peso: element1.total_peso,
              total_volumen: element1.total_volumen,
            });
          }
        }
      });
    });
    this.listadoSeleccionadosAsignadosTotales = _.cloneDeep(this.listadoSeleccionadosAsignados);
    this.listadoSeleccionadosAsignadosTotales.forEach((mov) => {
      delete mov.__typename;
      delete mov.estado;
      delete mov.estado_cliente;
      delete mov.nombre_cliente;
      delete mov.total_monto;
      delete mov.total_unidad;
      delete mov.total_cantidad;
      delete mov.total_volumen;
      delete mov.total_peso;
      delete mov.fecha_emision;
      delete mov.folio_recorrido_Detalle;
      delete mov.additionalInfo;
      delete mov.comuna_codigo;
      delete mov.vendedor_codigo;
      delete mov.territorio_codigo;
      delete mov.prioridad;
    });
    const inputParams = {
      lista: this.listadoSeleccionadosAsignadosTotales,
    };
    this.ruteadorService.obtenerTotalesAsignacion(inputParams, ({ respuesta }) => {
      if (respuesta == null) {
        this.loadingDetalles = false;
        return;
      }
      let listaDocAsignadoTotalesSelect = respuesta;
      this.sumCajasSelect = listaDocAsignadoTotalesSelect.total_cantidad;
      this.sumUnidadSelect = listaDocAsignadoTotalesSelect.total_unidad;
      this.sumPesoSelect = Math.round(_.sumBy(this.listadoSeleccionadosAsignados, 'total_peso'));
      this.sumVolumenSelect = _.sumBy(this.listadoSeleccionadosAsignados, 'total_volumen').toFixed(2);
      this.sumMontoSelect = _.sumBy(this.listadoSeleccionadosAsignados, 'total_monto');
    });
  }

  createCustomMarker(color: string): string {
    // return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
    //   <svg width="45" height="45" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    //     <polygon points="20,30 30,10 10,10"  fill="${color}" stroke="black" stroke-width="2"/>
    //   </svg>
    // `);

    return (
      'data:image/svg+xml;charset=UTF-8,' +
      encodeURIComponent(`
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" xml:space="preserve">
        <style type="text/css"> .st0{fill:none;}</style>
        <circle cx="8" cy="8" r="7" fill="${color}" stroke="white" stroke-width="1"/>
        <rect class="st0" width="16" height="16"/>
       </svg>
    `)
    );
  }

  obtenerCodigoColor(element: any): string {
    // Paleta de colores mejorada para mejor diferenciación visual
    const coloresDiferenciados = [
      '#FF4444', // Rojo vibrante
      '#44FF44', // Verde vibrante
      '#4444FF', // Azul vibrante
      '#FFAA00', // Naranja
      '#AA44FF', // Púrpura
      '#FF44AA', // Rosa/Magenta
      '#44AAAA', // Cian
      '#AAAA44', // Amarillo verdoso
      '#AA4444', // Rojo oscuro
      '#44AA44', // Verde oscuro
      '#4444AA', // Azul oscuro
      '#FF8800', // Naranja oscuro
      '#8844FF', // Púrpura oscuro
      '#FF4488', // Rosa oscuro
      '#448888', // Cian oscuro
      '#888844', // Oliva
      '#FF6666', // Rojo claro
      '#66FF66', // Verde claro
      '#6666FF', // Azul claro
      '#FFBB66'  // Naranja claro
    ];

    // Usar el código del recorrido para seleccionar un color de la paleta
    const colorIndex = element.recorrido_codigo % coloresDiferenciados.length;
    return coloresDiferenciados[colorIndex];
  }

  componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
  }

  obtenerNumeroAleaotrio(min, max) {
    let numAle = Math.random() * (max - min) + min;
    return Math.round(numAle);
  }

  obtenerResumenDocumentos() {
    const { filtroEstado, filtroComuna, filtroVendedor, filtroTerritorio } = this.formFiltrosDocumentos.value;
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formFiltrosDocumentos.get('filtroFechaDesde').value,
      fechaHasta: this.formFiltrosDocumentos.get('filtroFechaHasta').value,
      estado: parseInt(filtroEstado),
      rut_empresa: this.rutEmpresa,
      comuna_codigo: filtroComuna === '' || filtroComuna === null || filtroComuna === undefined ? [] : filtroComuna,
      vendedor_codigo: filtroVendedor === '' || filtroVendedor === null || filtroVendedor === undefined ? [] : filtroVendedor,
      territorio_codigo: filtroTerritorio === '' || filtroTerritorio === null || filtroTerritorio === undefined ? [] : filtroTerritorio,
    };
    this.ruteadorService.obtenerResumenDocumentos(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      var resumen = registros;

      if (resumen.length > 0) {
        this.total_documentos = resumen[0].total_documentos;
        this.documentos_entregados = resumen[0].documentos_entregados;
        this.documentos_pendientes = resumen[0].documentos_pendientes;
        this.numeros_clientes = resumen[0].numeros_clientes;
      }
    });
  }

  ObtenerCamiones(fechaDesde: string, fechaHasta: string, estado: string) {
    this.listadoCamionChofer = [];
    const inputParams = {
      fechaDesde: fechaDesde,
      fechaHasta: fechaHasta,
      estado: estado,
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
    };

    this.loadingCamion = true;
    this.ruteadorService.obtenerCamionChofer(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        this.loadingCamion = false;
        return;
      }

      const { registros } = respuesta;
      this.listadoCamionChofer = registros;
      this.loadingCamion = false;
      this.checkAllRecorrido = false;
      this.listadoCamionChofer.forEach((element) => {
        element.correlativo = element.recorrido_codigo;
        const foundElement = this.beachesAll.find((x) => x.recorrido_codigo == element.recorrido_codigo);
        element.color = foundElement ? foundElement.color : '';
        element.seleccion = false;
      });
    });
  }

  onMapReady(map) {
    this.globalMap = map;
    this.optionsManejosMapa(map);

    // Asegurar que el mapa se centre en Chile si no hay marcadores
    if (this.beaches.length === 0) {
      map.setCenter(new google.maps.LatLng(this.defaultLatitude, this.defaultLongitude));
      map.setZoom(this.defaultZoom);
    }
  }

  optionsManejosMapa(map: google.maps.Map) {
    const options = {
      drawingControl: true, // Mostrar controles de dibujo en el mapa
      disableDefaultUI: true, // Deshabilitar la interfaz predeterminada si es necesario
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_LEFT, // Posición de los controles en el mapa
        drawingModes: [
          google.maps.drawing.OverlayType.POLYGON, // Modos de dibujo permitidos (polígonos)
        ],
      },
      polygonOptions: {
        draggable: false, // Permitir arrastrar los polígonos
        editable: true, // Permitir editar los vértices de los polígonos
      },
      drawingMode: google.maps.drawing.OverlayType.POLYGON, //Inicia con la herramienta de hacer poligono si lo dejas en null inicia con el control de arrastre
    };
    this.drawingManager = new google.maps.drawing.DrawingManager(options);

    // Capturar el clic derecho en el mapa y evitar el menú contextual
    google.maps.event.addListener(map, 'rightclick', function (event) {
      console.log('Clic derecho detectado, pero no se muestra menú contextual.');
    });

    // Cerrar el infoWindow al cambiar la herramienta
    google.maps.event.addListener(this.drawingManager, 'drawingmode_changed', () => {
      this.close_previous_info_window();
    });

    // También puedes cerrar el infoWindow cuando el usuario hace clic en el mapa
    google.maps.event.addListener(map, 'click', () => {
      this.close_previous_info_window();
    });

    this.drawingManager.setMap(map);
  }


  // Método para cerrar todos los InfoWindows
  close_previous_info_window() {
    if (this.infoWindows) {
      this.infoWindows.forEach((infoWindow) => {
        try {
          infoWindow.close();
        } catch (error) {
          console.error('Error al cerrar un InfoWindow:', error);
        }
      });
    }
  }

  // Método para manejar la selección de un marcador
  select_marker(infoWindow: AgmInfoWindow) {
    if (infoWindow) {
      // Cerrar todos los InfoWindows antes de abrir el nuevo
      this.close_previous_info_window();

      try {
        infoWindow.open();
        console.log('Nuevo InfoWindow abierto correctamente.');
      } catch (error) {
        console.error('Error al intentar abrir el InfoWindow:', error);
      }
    } else {
      console.error('El InfoWindow proporcionado no es válido.');
    }
  }

  handlePolygonComplete(polygon: google.maps.Polygon) {
    if (this.polygon) {
      this.polygon.setMap(null);
    }
    this.polygon = polygon;

    // Asegurarse de que el polígono esté en el mapa
    this.polygon.setMap(this.globalMap);
  }

  initDrawingManager(map: google.maps.Map) {
    var polygonArray3 = [];
    var beaches_ = this.beaches;
    var markers_ = [];
    google.maps.event.clearListeners(map, 'polygoncomplete');

    this.zoomeExtends(map, this.beaches);
  }

  opcionsPoligono() {
    google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (polygon) => {
      if (this.polygon) {
        this.polygon.setMap(null);
      }
      this.polygon = polygon;

      document.getElementById('info').innerHTML = '';

      const polygonArray3 = [];

      for (let i = 0; i < polygon.getPath().getLength(); i++) {
        const puntospol = polygon.getPath().getAt(i).toUrlValue(6);
        const coords = puntospol.split(',');
        const latLng = this.createLatLngIfValid(coords[0], coords[1]);
        if (latLng) {
          polygonArray3.push(latLng);
        }
      }

      const bermudaTriangle = new google.maps.Polygon({
        paths: [polygonArray3],
      });

      const markers_ = [];
      for (let i = 0; i < this.beaches.length; i++) {
        const beach = this.beaches[i];
        const marker = this.createMarkerIfValid(beach);
        if (marker) {
          markers_.push(marker);
        }
      }
      for (let i = 0; i < markers_.length; i++) {
        const marker = markers_[i];
        if (google.maps.geometry.poly.containsLocation(marker.getPosition(), bermudaTriangle)) {
          document.getElementById('info').innerHTML += marker.getPosition() + ';';
        }
      }

      this.drawingManager.setDrawingMode(null);
      this.polygon.setMap(null);
      this.onPolygonComplete(polygon);

      // Evento de clic al polígono completado
      google.maps.event.addListener(polygon, 'click', (event) => {
        this.close_previous_info_window();
        this.onPolygonClick(event, polygon);
      });

      // Evento de clic al polígono completado
      google.maps.event.addListener(polygon, 'rightclick', (event) => {
        this.close_previous_info_window();
        this.showModalAsignarCamionRutas();
      });

      //Evento cuando edita un poligono
      google.maps.event.addListener(polygon.getPath(), 'set_at', (event) => {
        this.close_previous_info_window();
        this.updatePolygonInfo(event, polygon);
      });
      google.maps.event.addListener(polygon.getPath(), 'insert_at', (event) => {
        this.close_previous_info_window();
        this.updatePolygonInfo(event, polygon);
      });
      google.maps.event.addListener(polygon.getPath(), 'remove_at', (event) => {
        this.close_previous_info_window();
        this.updatePolygonInfo(event, polygon);
      });
    });
  }

  // Función para procesar todos los vértices
  updatePolygonInfo(event, polygon) {
    this.polygon = polygon;
    document.getElementById('info').innerHTML = '';
    const polygonArray3 = [];

    for (let i = 0; i < polygon.getPath().getLength(); i++) {
      const puntospol = polygon.getPath().getAt(i).toUrlValue(6);
      const coords = puntospol.split(',');
      const latLng = this.createLatLngIfValid(coords[0], coords[1]);
      if (latLng) {
        polygonArray3.push(latLng);
      }
    }

    const bermudaTriangle = new google.maps.Polygon({
      paths: [polygonArray3],
    });

    const markers_ = [];
    for (let i = 0; i < this.beaches.length; i++) {
      const beach = this.beaches[i];
      const marker = this.createMarkerIfValid(beach);
      if (marker) {
        markers_.push(marker);
      }
    }
    for (let i = 0; i < markers_.length; i++) {
      const marker = markers_[i];
      if (google.maps.geometry.poly.containsLocation(marker.getPosition(), bermudaTriangle)) {
        document.getElementById('info').innerHTML += marker.getPosition() + ';';
      }
    }
    this.handlePolygonEdit(event, polygon);

  }

  handlePolygonEdit(event: MouseEvent, polygon: google.maps.Polygon) {
    var localizaciones = document.getElementById('info').innerHTML;
    this.beachesSeleccionados = [];

    if (localizaciones !== '') {
      var split = localizaciones.split(';');
      split.forEach((element) => {
        var replace = element.replace('(', '').replace(')', '').replace(/ /g, '');
        var splitL = replace.split(',');
        if (splitL[0] !== '') {
          this.beachesSeleccionados.push({
            latitud: splitL[0],
            longitud: splitL[1],
          });
        }
      });

      let beachesSeleccionadosDistinc = this.beachesSeleccionados.filter((thing, i, arr) => arr.findIndex((t) => t.latitud === thing.latitud) === i);
      this.beachesSeleccionados = [];

      beachesSeleccionadosDistinc.forEach((element) => {
        let sel2 = { latitud: element.latitud, longitud: element.longitud };
        this.beachesSeleccionados.push(sel2);
      });
    }
    //this.log('', JSON.stringify(this.beachesSeleccionados));
    const filtroFecha = this.formFiltrosDocumentos.get('filtroFechaDesde').value; // return
    this.resultadoAsignacionModal.loadAndShow(
      this.beachesSeleccionados,
      this.documentosRecorridos,
      this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
      filtroFecha
    );
    this.onPolygonComplete(polygon);
  }

  onMarkerRightClick(beaches: any) {
    this.log(`Clic derecho` + beaches);
    const esAsinado = beaches.recorrido_codigo === 0 ? false : true;
    const title = 'Opciones Agsinacion';
    const message = beaches.recorrido_codigo === 0 ? '¿Desea Asignar a un recorrido?' : '¿Desea Liberar Reasignar a un recorrido?';
    this.modalOpcionesAgsinacion.showWithInlineConfig(
      title,
      message,
      esAsinado,
      //Asignar
      () => {
        this.asignarMarcador(beaches);
      },
      //Reasignar
      () => {
        this.reasignarMarcador(beaches);
      },
      //Liberar
      () => {
        this.liberacionMarcador(beaches);
      }
    );
  }

  asignarMarcador(beaches: any) {
    const markers_ = [];
    const marker = this.createMarkerIfValid(beaches);
    if (marker) {
      markers_.push(marker);
    }
    document.getElementById('info').innerHTML = '';
    for (let i = 0; i < markers_.length; i++) {
      const marker = markers_[i];
      document.getElementById('info').innerHTML += marker.getPosition() + ';';
    }
    this.showModalAsignarCamionRutas();
  }

  async reasignarMarcador(beaches: any) {
    this.listadoSeleccionadosLiberar = [];
    this.listadoSeleccionadosLiberar = beaches.info.documento
      .split(',')
      .map((doc) => parseInt(doc.trim(), 10))
      .filter((doc) => !isNaN(doc));
    var docList: any[] = [];
    this.listadoSeleccionadosLiberar.forEach((value) => {
      var data = {
        folio: value,
        cliente_proveedor_rut: beaches.cliente_proveedor_rut,
        tipo_dte_codigo: beaches.info.tipo_dte_codigo,
        recorrido_codigo: beaches.recorrido_codigo,
      };
      docList.push(Object.assign({}, data));
    });
    var inputParams: any = {
      entidad: {
        objet: docList,
      },
    };

    this.log('ELIMINAR LISTA RECORRIDOS DETALLE', JSON.stringify(inputParams));

    this.recorridoDetalleService.eliminarListaByFolioTipoDocumento(inputParams, ({ mensajes, respuesta }) => {
      // this.log('ELIMINACION DE LISTA RECORRIDOS DETALLE', JSON.stringify(respuesta, mensajes));

      if (mensajes && mensajes.length > 0) {
        console.log('err');
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      // docList.forEach((value) => {
      //   this.listadoDetalleCamionChofer = this.listadoDetalleCamionChofer.filter((p) => p.numero_documento !== value.folio);
      // });

      this.listadoSeleccionadosLiberar = [];
      this.buscarPorFiltros();

      const markers_ = [];
      const marker = this.createMarkerIfValid(beaches);
      if (marker) {
        markers_.push(marker);
      }

      this.documentosRecorridos.forEach((x) => {
        if (x.recorrido_codigo === beaches.recorrido_codigo) {
          x.folio_recorrido_Detalle = 0;
        }
      });

      document.getElementById('info').innerHTML = '';
      for (let i = 0; i < markers_.length; i++) {
        const marker = markers_[i];
        document.getElementById('info').innerHTML += marker.getPosition() + ';';
      }
      this.showModalAsignarCamionRutas();
    });
  }

  liberacionMarcador(beaches: any) {
    this.listadoSeleccionadosLiberar = [];
    this.listadoSeleccionadosLiberar = beaches.info.documento
      .split(',')
      .map((doc) => parseInt(doc.trim(), 10))
      .filter((doc) => !isNaN(doc));
    var docList: any[] = [];
    this.listadoSeleccionadosLiberar.forEach((value) => {
      var data = {
        folio: value,
        cliente_proveedor_rut: beaches.cliente_proveedor_rut,
        tipo_dte_codigo: beaches.info.tipo_dte_codigo,
        recorrido_codigo: beaches.recorrido_codigo,
      };
      docList.push(Object.assign({}, data));
    });
    var inputParams: any = {
      entidad: {
        objet: docList,
      },
    };

    this.log('ELIMINAR LISTA RECORRIDOS DETALLE', JSON.stringify(inputParams));

    this.recorridoDetalleService.eliminarListaByFolioTipoDocumento(inputParams, ({ mensajes, respuesta }) => {
      // this.log('ELIMINACION DE LISTA RECORRIDOS DETALLE', JSON.stringify(respuesta, mensajes));

      if (mensajes && mensajes.length > 0) {
        console.log('err');
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      // docList.forEach((value) => {
      //   this.listadoDetalleCamionChofer = this.listadoDetalleCamionChofer.filter((p) => p.numero_documento !== value.folio);
      // });

      this.listadoSeleccionadosLiberar = [];
      this.buscarPorFiltros();

      // document.getElementById('info').innerHTML = '';
    });
  }

  removePolygon() {
    if (this.polygon) {
      this.polygon.setMap(null);
      this.polygon = null;
    }
    this.sumCajasSelect = 0;
    this.sumUnidadSelect = 0;
    this.sumPesoSelect = 0;
    this.sumVolumenSelect = 0;
    this.sumMontoSelect = 0;
    this.listadoSeleccionadosAsignados = [];
  }

  onPolygonComplete(polygon: google.maps.Polygon) {
    console.log('Polígono completado:', polygon);
    var localizaciones = document.getElementById('info').innerHTML;
    this.beachesSeleccionados = [];

    if (localizaciones !== '') {
      var split = localizaciones.split(';');
      split.forEach((element) => {
        var replace = element.replace('(', '').replace(')', '').replace(/ /g, '');
        var splitL = replace.split(',');
        if (splitL[0] !== '') {
          this.beachesSeleccionados.push({
            latitud: splitL[0],
            longitud: splitL[1],
          });
        }
      });

      let beachesSeleccionadosDistinc = this.beachesSeleccionados.filter((thing, i, arr) => arr.findIndex((t) => t.latitud === thing.latitud) === i);
      this.beachesSeleccionados = [];

      beachesSeleccionadosDistinc.forEach((element) => {
        let sel2 = { latitud: element.latitud, longitud: element.longitud };
        this.beachesSeleccionados.push(sel2);
      });

      // Aquí puedes manejar el polígono como desees al completarse
      const filtroFecha = this.formFiltrosDocumentos.get('filtroFechaDesde').value;

      this.resultadoAsignacionModal.loadAndShow(
        this.beachesSeleccionados,
        this.documentosRecorridos,
        this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
        filtroFecha
      );

      this.obtenerTotalesSeleccionPoligono(this.beachesSeleccionados, this.documentosRecorridos);
      this.handlePolygonComplete(polygon);
    } else {
      this.showInfo('Debe seleccionar al menos una localización.');
    }
  }

  onPolygonClick(event: MouseEvent, polygon: google.maps.Polygon) {
    console.log('Clic en el polígono:', polygon);
    var localizaciones = document.getElementById('info').innerHTML;
    this.beachesSeleccionados = [];

    if (localizaciones !== '') {
      var split = localizaciones.split(';');
      split.forEach((element) => {
        var replace = element.replace('(', '').replace(')', '').replace(/ /g, '');
        var splitL = replace.split(',');
        if (splitL[0] !== '') {
          this.beachesSeleccionados.push({
            latitud: splitL[0],
            longitud: splitL[1],
          });
        }
      });

      let beachesSeleccionadosDistinc = this.beachesSeleccionados.filter((thing, i, arr) => arr.findIndex((t) => t.latitud === thing.latitud) === i);
      this.beachesSeleccionados = [];

      beachesSeleccionadosDistinc.forEach((element) => {
        let sel2 = { latitud: element.latitud, longitud: element.longitud };
        this.beachesSeleccionados.push(sel2);
      });
    }
    //this.log('', JSON.stringify(this.beachesSeleccionados));
    const filtroFecha = this.formFiltrosDocumentos.get('filtroFechaDesde').value; // return
    this.resultadoAsignacionModal.loadAndShow(
      this.beachesSeleccionados,
      this.documentosRecorridos,
      this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
      filtroFecha
    );
  }

  // Función auxiliar para validar coordenadas
  private isValidCoordinate(lat: any, lng: any): boolean {
    const latNum = parseFloat(lat);
    const lngNum = parseFloat(lng);

    // Validaciones básicas
    if (isNaN(latNum) || isNaN(lngNum) || !isFinite(latNum) || !isFinite(lngNum)) {
      return false;
    }

    // Validar rangos de coordenadas para Chile
    // Latitud: aproximadamente entre -56 y -17 (Chile continental)
    // Longitud: aproximadamente entre -76 y -66 (Chile continental)
    if (latNum < -56 || latNum > -17 || lngNum < -76 || lngNum > -66) {
      console.warn(`Coordenada fuera de rango para Chile: lat=${latNum}, lng=${lngNum}`);
      return false;
    }

    // Validar que latitud y longitud no sean iguales (error común)
    if (Math.abs(latNum - lngNum) < 0.0001) {
      console.warn(`Coordenadas idénticas (posible error): lat=${latNum}, lng=${lngNum}`);
      return false;
    }
    return true;
  }

  // Función auxiliar para crear marcador con validación
  private createMarkerIfValid(beach: any): google.maps.Marker | null {
    try {
      if (this.isValidCoordinate(beach.latitud, beach.longitud)) {
        return new google.maps.Marker({
          position: new google.maps.LatLng(parseFloat(beach.latitud), parseFloat(beach.longitud)),
          title: beach.cliente_proveedor_nombre,
          zIndex: beach.contador,
        });
      } else {
        console.warn(`Coordenadas inválidas para ${beach.cliente_proveedor_nombre}: lat=${beach.latitud}, lng=${beach.longitud}`);
        return null;
      }
    } catch (error) {
      console.error(`Error al crear marcador para ${beach.cliente_proveedor_nombre}:`, error);
      return null;
    }
  }

  // Función auxiliar para crear LatLng con validación
  private createLatLngIfValid(lat: any, lng: any): google.maps.LatLng | null {
    try {
      if (this.isValidCoordinate(lat, lng)) {
        return new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      } else {
        console.warn(`Coordenadas inválidas para polígono: lat=${lat}, lng=${lng}`);
        return null;
      }
    } catch (error) {
      console.error(`Error al crear LatLng:`, error);
      return null;
    }
  }

  zoomeExtends(map: any, beachesP: any[]) {
    try {
      var beaches_ = beachesP;
      var validBeaches = [];

      console.log(`🔄 Procesando ${beaches_.length} puntos para el mapa...`);

      // Filtrar solo las coordenadas válidas
      for (let i = 0; i < beaches_.length; i++) {
        const beach = beaches_[i];
        if (this.isValidCoordinate(beach.latitud, beach.longitud)) {
          validBeaches.push(beach);
        } else {
          const latNum = parseFloat(beach.latitud);
          const lngNum = parseFloat(beach.longitud);
          let razonInvalida = '';

          if (isNaN(latNum) || isNaN(lngNum) || !isFinite(latNum) || !isFinite(lngNum)) {
            razonInvalida = 'Valores no numéricos';
          } else if (Math.abs(latNum - lngNum) < 0.0001) {
            razonInvalida = 'Latitud y longitud idénticas (error de datos)';
          } else if (latNum < -56 || latNum > -17 || lngNum < -76 || lngNum > -66) {
            razonInvalida = 'Fuera del rango geográfico de Chile';
          } else {
            razonInvalida = 'Coordenada inválida por otro motivo';
          }

          // Obtener información detallada del registro desde la estructura correcta
          const rutPersona = this.formatearRutConServicio(beach.cliente_proveedor_rut) || 'No disponible';
          const nombrePersona = beach.cliente_proveedor_nombre || 'No disponible';
          const direccionLocal = (beach.info && beach.info.address) ? beach.info.address : 'No disponible';
          const comuna = (beach.info && beach.info.comuna) ? beach.info.comuna : null;
          const coordenadas = `lat: ${beach.latitud}, lng: ${beach.longitud}`;

          console.log(`❌ Coordenada inválida omitida: RUT: ${rutPersona} | Nombre: ${nombrePersona} | Dirección: ${direccionLocal} | Comuna: ${comuna || 'N/A'} | Coordenadas: ${coordenadas} | Razón: ${razonInvalida}`);
        }
      }

      console.log(`📊 Total coordenadas válidas: ${validBeaches.length} de ${beaches_.length} puntos`);

      // Crear bounds para ajustar el zoom
      var bounds = new google.maps.LatLngBounds();
      if (validBeaches.length > 0) {
        for (var i = 0; i < validBeaches.length; i++) {
          try {
            const lat = parseFloat(validBeaches[i].latitud);
            const lng = parseFloat(validBeaches[i].longitud);
            bounds.extend(new google.maps.LatLng(lat, lng));
          } catch (error) {
            console.error(`Error al extender bounds con coordenada ${i}:`, error);
          }
        }

        try {
          map.fitBounds(bounds);
          console.log('✅ Mapa ajustado para mostrar todos los marcadores');
        } catch (error) {
          console.error('Error al ajustar bounds del mapa:', error);
          // Fallback: centrar en el primer marcador válido
          if (validBeaches.length > 0) {
            try {
              const firstBeach = validBeaches[0];
              map.setCenter(new google.maps.LatLng(parseFloat(firstBeach.latitud), parseFloat(firstBeach.longitud)));
              map.setZoom(10);
              console.log('✅ Mapa centrado en primer marcador como fallback');
            } catch (fallbackError) {
              console.error('Error en fallback del mapa:', fallbackError);
            }
          }
        }
      } else {
        console.warn('No hay coordenadas válidas para mostrar en el mapa');
        // Centrar el mapa en Chile cuando no hay coordenadas válidas
        try {
          map.setCenter(new google.maps.LatLng(this.defaultLatitude, this.defaultLongitude));
          map.setZoom(this.defaultZoom);
          console.log('✅ Mapa centrado en Chile por defecto');
        } catch (error) {
          console.error('Error al centrar el mapa en Chile:', error);
        }
      }
    } catch (error) {
      console.error('Error en zoomeExtends:', error);
    }
  }

  buscarPorFiltros() {
    //this.log('permiteUnidadNegocio', this.permiteUnidadNegocio, this.optionsUnidadesDeNegocio);
    if (this.permiteUnidadNegocio && !this.formFiltrosDocumentos.get('unidad_negocio_codigo').value) {
      return;
    }

    // Activar indicador de carga
    this.loadingBusqueda = true;
    console.log('🔄 Iniciando búsqueda con filtros...');

    this.removePolygon();
    this.obtenerDocumentosRecorridoByFiltro();
    this.obtenerResumenDocumentos();
  }

  limpiarFiltros() {
    // Guardar el valor actual de filtroEstado
    const filtroEstadoActual = this.formFiltrosDocumentos.get('filtroEstado').value;
    const filtroFechaDesdeActual = this.formFiltrosDocumentos.get('filtroFechaDesde').value;
    const filtroFechaHastaActual = this.formFiltrosDocumentos.get('filtroFechaHasta').value;
    const unidadNegocioSeleccionada = this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0;
    // Resetear el formulario
    this.formValidatorsService.reset(this.formFiltrosDocumentos);
    const { currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.listaDocumentosRecorridos = [];
    this.optionsComuna = [];
    this.optionsVendedor = [];
    this.optionsTerritorios = [];
    this.formFiltrosDocumentos.get('estadofiltroDetalleRecorrido').setValue('0');
    //*Estado no se debe limpia*/
    this.formFiltrosDocumentos.get('filtroEstado').setValue(filtroEstadoActual);
    this.formFiltrosDocumentos.get('unidad_negocio_codigo').setValue(unidadNegocioSeleccionada);
    this.formFiltrosDocumentos.get('filtroFechaDesde').setValue(filtroFechaDesdeActual);
    this.formFiltrosDocumentos.get('filtroFechaHasta').setValue(filtroFechaHastaActual);
    this.formFiltrosDocumentos.get('fechafiltroDetalleRecorrido').setValue(currentDate);
    this.formFiltrosDocumentos.get('fechafiltroDetalleRecorridoHasta').setValue(currentDate);
    document.getElementById('info').innerHTML = '';

    this.buscarPorFiltros();
  }

  showModalAsignarCamionRutas(editar: boolean = false) {
    var localizaciones = document.getElementById('info').innerHTML;
    this.beachesSeleccionados = [];

    if (localizaciones !== '' || editar) {
      var split = localizaciones.split(';');
      split.forEach((element) => {
        var replace = element.replace('(', '').replace(')', '').replace(/ /g, '');
        var splitL = replace.split(',');
        if (splitL[0] !== '') {
          this.beachesSeleccionados.push({
            latitud: splitL[0],
            longitud: splitL[1],
          });
        }
      });

      let beachesSeleccionadosDistinc = this.beachesSeleccionados.filter((thing, i, arr) => arr.findIndex((t) => t.latitud === thing.latitud) === i);
      this.beachesSeleccionados = [];

      beachesSeleccionadosDistinc.forEach((element) => {
        let sel2 = { latitud: element.latitud, longitud: element.longitud };
        this.beachesSeleccionados.push(sel2);
      });

      const filtroFecha = this.formFiltrosDocumentos.get('filtroFechaDesde').value; // return
      this.modalAsignarCamion.show(
        this.beachesSeleccionados,
        this.documentosRecorridos,
        this.listadoCamionChofer,
        this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
        filtroFecha,
        editar
      );
    } else {
      this.showInfo('Debe seleccionar al menos una localización.');
    }
    //si no se limpia, queda las localizaciones tomadas
    localizaciones = null;
  }

  showModalAsignarAutomaticaCamionRutas(editar: boolean = false) {
    let beachesSeleccionadosDistinc = this.beachesAll.filter((thing, i, arr) => arr.findIndex((t) => t.latitud === thing.latitud && t.recorrido_codigo === 0) === i);
    this.beachesSeleccionados = [];

    beachesSeleccionadosDistinc.forEach((element) => {
      let sel2 = { latitud: element.latitud, longitud: element.longitud };
      this.beachesSeleccionados.push(sel2);
    });

    const filtroFechaDesde = this.formFiltrosDocumentos.get('filtroFechaDesde').value; // return
    const filtroFechaHasta = this.formFiltrosDocumentos.get('filtroFechaHasta').value; // return
    this.modalAsignarAutomaticaCamion.show(
      this.beachesSeleccionados,
      this.documentosRecorridos,
      this.permiteUnidadNegocio ? this.formFiltrosDocumentos.get('unidad_negocio_codigo').value : 0,
      filtroFechaDesde,
      filtroFechaHasta,
      editar
    );
    // Reactiva la herramienta de trazo después de mostrar el modal
    setTimeout(() => {
      this.restaurarEstadoMapaYTrazo();
    }, 100);
  }

  onPageChangeDetalles(context: PaginationContext) {
    this.showPageDetalles(context.RequestedPage);
  }

  downloadExcelPdf(type: 'XLS' | 'PDF', cam: any): void {
    const inputParams = {
      excel: type === 'XLS' ? true : false,
      recorrido_codigo: cam.recorrido_codigo,
    };
    this.ruteadorService.obtenerDetalleCamionChofer(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
      console.log(
        '🚀 ~ file: ruteador.component.ts ~ line 1485 ~ RuteadorComponent ~ this._ruteadorService.obtenerDetalleCamionChofer ~ respuesta.registros[0].rutaArchivo',
        respuesta.registros[0].rutaArchivo
      );
    });
  }

  ReAsignarRecorridoDetalleList() {
    this.tittle = 'Reasignar';
    if (this.listadoDetalleDocumentos.length > 1) {
      this.message = '¿Está seguro de reasignar los registros?';
    } else {
      this.message = '¿Está seguro de reasignar el registro?';
    }

    this.listadoDetalleCamionChoferAll = [];
    this.modalConfirm.show(() => {
      this.ReAsignarListaRecorridoDetalle();
      // this.updateRecorridoDetalle();
    });
  }

  ReAsignarListaRecorridoDetalle = () => {
    var docList: any[] = [];
    var docListAsig: any[] = [];
    this.listadoDetalleDocumentos.forEach((value) => {
      var data = {
        folio: value.numero_documento,
        cliente_proveedor_rut: value.cliente_proveedor_rut,
        tipo_dte_codigo: value.tipo_documento,
        recorrido_codigo: value.recorrido_codigo,
        fecha_emision_folio: value.fecha_emision_folio,
      };
      docList.push(Object.assign({}, data));
      docListAsig.push(Object.assign({}, data));
    });

    //Bandera para reasignar
    var inputReasignar: any = {
      entidad: {
        objet: docListAsig,
      },
    };

    // PARA ELIMINAR
    var inputParams: any = {
      entidad: {
        objet: docList,
      },
    };

    inputParams.entidad.objet.map((x) => {
      delete x.fecha_emision_folio;
    });
    this.log('ELIMINAR LISTA RECORRIDOS DETALLE', JSON.stringify(inputParams));
    this.recorridoDetalleService.eliminarListaByFolioTipoDocumento(inputParams, ({ mensajes, respuesta }) => {
      this.log('ELIMINACION DE LISTA RECORRIDOS DETALLE', JSON.stringify(respuesta, mensajes));

      if (mensajes && mensajes.length > 0) {
        console.log('err');
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      docList.forEach((value) => {
        this.listadoDetalleCamionChofer = this.listadoDetalleCamionChofer.filter((p) => p.numero_documento !== value.folio);
      });

      this.listadoDetalleDocumentos = [];
      this.buscarPorFiltros();

      document.getElementById('info').innerHTML = '';
    });
  };

  eliminarRecorridoDetalleList() {
    this.tittle = 'Liberar';
    if (this.listadoDetalleDocumentos.length > 1) {
      this.message = '¿Está seguro de liberar los registros?';
    } else {
      this.message = '¿Está seguro de liberar el registro?';
    }

    this.listadoDetalleCamionChoferAll = [];
    this.modalConfirm.show(() => {
      this.eliminarListaRecorridoDetalle();
      this.updateRecorridoDetalle();
    });
  }

  guardarPrioridades() {
    if (!this.listadoDetalleCamionChoferAll || this.listadoDetalleCamionChoferAll.length === 0) {
      this.showError('No hay documentos para guardar prioridades');
      return;
    }

    // Preparar los datos para guardar, asegurando que valores vacíos sean 0
    const documentosConPrioridad = this.listadoDetalleCamionChoferAll.map(detCam => {
      // Asegurar que la prioridad sea un número válido, si no, usar 0
      let prioridad = detCam.prioridad;
      if (prioridad === null || prioridad === undefined || isNaN(prioridad) || prioridad === '') {
        prioridad = 0;
      }
      prioridad = Math.max(0, Math.min(10, Math.round(prioridad))); // Asegurar que esté entre 0 y 10

      return {
        numero_documento: detCam.numero_documento,
        tipo_documento: detCam.tipo_documento,
        cliente_proveedor_rut: detCam.cliente_proveedor_rut,
        recorrido_codigo: detCam.recorrido_codigo,
        prioridad: prioridad
      };
    });

    const inputParams = {
      entidad: {
        recorrido_codigo: this.recorridoDetalleSeleccionado.recorrido_codigo,
        documentos_con_prioridad: documentosConPrioridad,
        rut_empresa: this.rutEmpresa
      }
    };

    this.log('GUARDAR PRIORIDADES', JSON.stringify(inputParams));

    // Mostrar mensaje de confirmación
    this.tittle = 'Guardar Prioridades';
    this.message = '¿Está seguro de guardar las prioridades? \n Esto reordenará la ruta según las prioridades asignadas.';

    this.modalConfirm.show(() => {
      // Aquí iría la llamada al servicio para guardar prioridades
      this.guardarPrioridadesEnServicio(inputParams);
    });
  }

  private guardarPrioridadesEnServicio(inputParams: any) {
    // llamada al servicio
    console.log('Guardando prioridades:', inputParams);

    // Actualizar las prioridades en el listado local sin reordenar
    this.listadoDetalleCamionChoferAll.forEach(detCam => {
      if (detCam.prioridad === null || detCam.prioridad === undefined || isNaN(detCam.prioridad) || detCam.prioridad === '') {
        detCam.prioridad = 0;
      }
      detCam.prioridad = Math.max(0, Math.min(10, Math.round(detCam.prioridad)));
    });

    // No reordenar aquí para mantener el orden original en la vista de detalle
    // El ordenamiento solo se aplicará cuando se muestren las rutas

    // Actualizar la vista paginada
    this.showPageDetalles(this.paginationContextDetalles.CurrentPage);

    // Llamada al servicio:
    this.ruteadorService.guardarPrioridades(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0 && mensajes[0].tipo === 'ERROR') {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.showSuccess('Prioridades guardadas correctamente. La ruta ha sido reordenada según las prioridades asignadas.');
      // Recargar los datos desde el servidor para asegurar consistencia
      this.obtenerDetalleCamionChofer(this.recorridoDetalleSeleccionado);
      // Cerrar el modal después de guardar exitosamente
      this.verDetalleCamionChoferModal.hide();
    });

  }

  eliminarListaRecorridoDetalle = () => {
    var docList: any[] = [];
    this.listadoDetalleDocumentos.forEach((value) => {
      var data = {
        folio: value.numero_documento,
        cliente_proveedor_rut: value.cliente_proveedor_rut,
        tipo_dte_codigo: value.tipo_documento,
        recorrido_codigo: value.recorrido_codigo,
      };
      docList.push(Object.assign({}, data));
    });
    var inputParams: any = {
      entidad: {
        objet: docList,
      },
    };

    this.log('ELIMINAR LISTA RECORRIDOS DETALLE', JSON.stringify(inputParams));

    this.recorridoDetalleService.eliminarListaByFolioTipoDocumento(inputParams, ({ mensajes, respuesta }) => {
      this.log('ELIMINACION DE LISTA RECORRIDOS DETALLE', JSON.stringify(respuesta, mensajes));

      if (mensajes && mensajes.length > 0) {
        console.log('err');
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      docList.forEach((value) => {
        this.listadoDetalleCamionChofer = this.listadoDetalleCamionChofer.filter((p) => p.numero_documento !== value.folio);
      });

      this.listadoDetalleDocumentos = [];
      this.buscarPorFiltros();

      document.getElementById('info').innerHTML = '';
    });

    if (this.listadoDetalleCamionChoferAll.length == this.listadoDetalleDocumentos.length) {
      this.verDetalleCamionChoferModal.hide();
    }
  };

  updateRecorridoDetalle(): void {
    //LIMPIAR MODAL
    this.verDetalleCamionChoferModal.hide();
    this.verDetalleCamionChoferModal.show();
    this.obtenerDetalleCamionChofer(this.recorridoDetalleSeleccionado);
  }


  /**
   * Formatea un RUT usando el servicio RutService y agregando puntos
   * @param rut RUT sin formato (ej: 16375768)
   * @returns RUT formateado (ej: 16.375.768-0) o el valor original si no es válido
   */
  private formatearRutConServicio(rut: any): string {
    if (!rut) return 'No disponible';

    try {
      // Usar el servicio RutService para agregar el dígito verificador
      const rutConDV = this.rutService.AgregarDV(rut);

      // Separar número y dígito verificador
      const numero = rutConDV.slice(0, -1);
      const dv = rutConDV.slice(-1);

      // Formatear con puntos
      const numeroFormateado = numero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      return `${numeroFormateado}-${dv}`;
    } catch (error) {
      console.warn('Error al formatear RUT:', error);
      return rut.toString();
    }
  }

  eliminarRecorrido(cam: any) {
    this.tittle = 'Liberar';
    this.message = '¿Está seguro de liberar el registro?';

    const inputParams = {
      entidad: {
        recorrido_codigo: cam.recorrido_codigo,
        rut_emisor: this.rutEmpresa,
      },
    };

    this.log('ELIMINAR RECORRIDO', JSON.stringify(inputParams));

    this.modalConfirm.show(() => {
      this.recorridoDetalleService.eliminarRecorrido(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        this.log('ELIMINACIÓN DE RECORRIDO', JSON.stringify(mensajes, respuesta));

        this.showSuccess('Operación Realizada');
        this.buscarPorFiltros();
        this.listadoDetalleCamionChofer.splice(0, this.listadoDetalleCamionChofer.length);
        this.listadoDetalleCamionChofer = [];
      });
    });
  }

  checkAll(event): void {
    if (event.checked) {
      this.listadoDetalleDocumentos = this.listadoDetalleCamionChofer;
    } else {
      this.listadoDetalleDocumentos = [];
    }
  }

  checkHandle(event: any, doc: any): void {
    if (event.checked) {
      this.listadoDetalleDocumentos.push(doc);
    } else {
      this.listadoDetalleDocumentos = this.listadoDetalleDocumentos.filter((x) => x.numero_documento !== doc.numero_documento);
    }
  }

  isChecked(docNum: number): boolean {
    return this.listadoDetalleDocumentos.some((x) => x.numero_documento === docNum);
  }

  public myDatePickerOptions: IMyOptions = {
    editableDateField: false,
  };

  buscarRecorridos() {
    const estado = this.formFiltrosDocumentos.get('estadofiltroDetalleRecorrido').value;
    const fecha = this.formFiltrosDocumentos.get('fechafiltroDetalleRecorrido').value;
    const fechaHastaDetalle = this.formFiltrosDocumentos.get('fechafiltroDetalleRecorridoHasta').value;
    this.ObtenerCamiones(fecha, fechaHastaDetalle, estado);
  }

  obtenerDetalleCamionChofer(cam: any) {
    this.loadingDetalles = true;
    this.recorridoDetalleSeleccionado = cam;

    const inputParams = {
      excel: false,
      recorrido_codigo: cam.recorrido_codigo,
    };

    this.log('OBTENER DETALLE CAMION CHOFER', JSON.stringify(inputParams));

    this.ruteadorService.obtenerDetalleCamionChofer(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      this.log('OBTENCION DE DETALLE CAMION', JSON.stringify(respuesta));

      const { registros } = respuesta;

      // No reordenar para mantener el orden original en el modal de detalle
      this.listadoDetalleCamionChoferAll = registros;

      console.log('Registros obtenidos:', registros);

      this.obtenerTotales(this.listadoDetalleCamionChoferAll);
      this.paginationContextDetalles.RecordsCount = this.listadoDetalleCamionChoferAll.length; //totalRegistros
      this.paginationContextDetalles.PagesCount = Math.ceil(this.paginationContextDetalles.RecordsCount / this.paginationContextDetalles.RecordsByPage); //totalPaginas

      this.showPageDetalles(this.paginationContextDetalles.CurrentPage);

      this.loadingDetalles = false;
    });
  }

  obtenerDetalleCamionChoferRutas(cam: any) {
    this.loadingDetalles = true;

    // Si ya tenemos los datos cargados del mismo recorrido, usar esos datos locales
    // que incluyen las prioridades que el usuario puede haber cambiado
    if (this.recorridoDetalleSeleccionado &&
      this.recorridoDetalleSeleccionado.recorrido_codigo === cam.recorrido_codigo &&
      this.listadoDetalleCamionChoferAll &&
      this.listadoDetalleCamionChoferAll.length > 0) {

      console.log('=== USANDO DATOS LOCALES PARA RUTAS (CON PRIORIDADES ACTUALIZADAS) ===');

      // Usar los datos locales que ya tienen las prioridades actualizadas
      this.generarRutasOrdenadas();
      this.loadingDetalles = false;

      // Verificar si hay más de 25 puntos (límite de Google Maps)
      if (this.beaches_rutas.length > this.GOOGLE_MAPS_WAYPOINT_LIMIT) {
        // Mostrar modal de rutas divididas
        this.verRutasDivididasModal.loadAndShow(this.beaches_rutas);
      } else {
        // Mostrar modal normal de rutas
        this.verRutasCamionModal.loadAndShow(this.beaches_rutas);
      }
      return;
    }

    // Si no tenemos datos o es un recorrido diferente, obtener del servidor
    this.recorridoDetalleSeleccionado = cam;

    const inputParams = {
      excel: false,
      recorrido_codigo: cam.recorrido_codigo,
    };

    this.log('OBTENER DETALLE CAMION CHOFER PARA RUTAS', JSON.stringify(inputParams));

    this.ruteadorService.obtenerDetalleCamionChofer(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      this.log('OBTENCION DE DETALLE CAMION PARA RUTAS', JSON.stringify(respuesta));

      const { registros } = respuesta;
      this.listadoDetalleCamionChoferAll = registros;

      console.log('=== DATOS OBTENIDOS DEL SERVIDOR PARA RUTAS ===');
      this.generarRutasOrdenadas();

      this.loadingDetalles = false;

      // Verificar si hay más de 25 puntos (límite de Google Maps)
      if (this.beaches_rutas.length > this.GOOGLE_MAPS_WAYPOINT_LIMIT) {
        // Mostrar modal de rutas divididas
        this.verRutasDivididasModal.loadAndShow(this.beaches_rutas);
      } else {
        // Mostrar modal normal de rutas
        this.verRutasCamionModal.loadAndShow(this.beaches_rutas);
      }
    });
  }

  private generarRutasOrdenadas() {
    // Ordenar los registros por prioridad antes de generar las rutas
    console.log('=== DATOS ANTES DEL ORDENAMIENTO (RUTAS) ===');
    this.listadoDetalleCamionChoferAll.forEach((element, index) => {
      console.log(`${index + 1}. ${element.direccion_completa} - Prioridad: ${element.prioridad || 'Sin prioridad'}`);
    });

    const registrosOrdenados = this.ordenarPorPrioridad(this.listadoDetalleCamionChoferAll);

    console.log('=== DATOS DESPUÉS DEL ORDENAMIENTO (RUTAS) ===');
    registrosOrdenados.forEach((element, index) => {
      console.log(`${index + 1}. ${element.direccion_completa} - Prioridad: ${element.prioridad || 'Sin prioridad'}`);
    });

    this.beaches_rutas = [];
    let contador = 0;
    registrosOrdenados.forEach((element) => {
      contador = contador + 1;
      this.beaches_rutas.push([
        element.direccion_completa,  // [0]
        element.latitud,             // [1]
        element.longitud,            // [2]
        contador,                    // [3]
        element.prioridad || 0,      // [4]
        element.numero_documento,    // [5] - ¡AQUÍ ESTABA EL PROBLEMA!
        element.comuna_despacho,     // [6]
        element.nombre_cliente       // [7]
      ]);
    });
  }

  showModalverAddEditRutasModal() {
    this.verAddEditRutasModal.showAdd();
  }

  showModalverAddEditRutasResultado() {
    this.resultadoAsignacionModal.clear();
    this.showModalAsignarCamionRutas();
  }

  showModalEditarRutasModal(cam: any) {
    this.verAddEditRutasModal.showEdit(cam);
  }

  showPageDetalles(pageNumber: number) {
    this.paginationContextDetalles.CurrentPage = pageNumber;
    const start = (this.paginationContextDetalles.CurrentPage - 1) * this.paginationContextDetalles.RecordsByPage;
    this.listadoDetalleCamionChofer = _.slice(this.listadoDetalleCamionChoferAll, start, start + this.paginationContextDetalles.RecordsByPage);
  }

  showModalVerDetalleCamionChofer(cam: any) {
    this.obtenerDetalleCamionChofer(cam);
    this.verDetalleCamionChoferModal.show();
  }

  despacharRecorrido(cam: any) {
    console.log('dame cam', cam);
    this.tittle = 'Despachar Camión';
    this.message = '¿Está seguro de realizar despacho?';
    this.modalConfirm.show(() => {
      this.despacharRecorridoAux(cam);
    });
  }

  despacharRecorridoAux(cam: any) {
    const inputParams = {
      entidad: {
        recorrido_codigo: cam.recorrido_codigo,
        despachado: true,
        rut_empresa: this.rutEmpresa,
      },
    };

    this.ruteadorService.despacharRecorrido(inputParams, ({ respuesta }) => {
      setTimeout(() => this.buscarPorFiltros(), 1000);
      this.showSuccess('La solicitud de despacho se ha realizado con éxito.');
    });
  }

  showModalmostrarRutas(cam: any) {
    this.obtenerDetalleCamionChoferRutas(cam);
  }

  // Método para manejar cuando se presiona el botón de mostrar ruta desde el modal de rutas divididas
  onMostrarRutaDesdeDivididas(event: any) {
    // Mostrar la ruta seleccionada en el mapa principal
    // Pasar el origen personalizado si está disponible (para rutas que no son la primera)
    this.verRutasCamionModal.loadAndShow(event.puntos, event.numeroRuta, event.origenPersonalizado);
  }

  // Método para manejar cuando se cierra el modal de rutas
  onCerrarRutaModal(numeroRuta: number) {
    // Resetear el color del bloque en el modal de división
    if (numeroRuta) {
      this.verRutasDivididasModal.resetearColorRuta(numeroRuta);
    }
  }

  showModalPdf_data(cam: any) {
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 7,
        categoria_modulo_codigo: 2,
        environment_functions: ENVIRONMENT_FUNCTIONS,
        rut_empresa: this.rutEmpresa,
        rut_usuario: this.rutUsuario,
        sucursal_codigo: this.sucursalCodigo,
        esDetalleRecorrido: false,
        listaRecorridos: this.listadoCamionChofer.filter((x) => x.seleccion).map((x) => ({
          recorrido_codigo: x.recorrido_codigo,
          total_facturas: x.total_facturas,
          total_documentos: x.total_documentos,
        })),
      }
    }

    console.log(inputParams);

    this.loadingPdf = true;
    this.messageLoading = 'Generando los PDFs... Una vez generados se mostrarán en las notificaciones';
    this.sendMessage(inputParams);
  }

  sendMessage(inputParams: any) {
    this.signalRMessageService.send(inputParams).subscribe(
      () => {
        console.log('Mensaje enviado con éxito');
      },
      (error) => {
        this.loadingPdf = false;
        console.error('Error al enviar el mensaje:', error);
      }
    );
  }

  showModalExcel_data(cam: any) {
    const inputParams = {
      recorrido_codigo: String(cam.recorrido_codigo),
      total_facturas: String(cam.total_facturas),
      total_documentos: String(cam.total_documentos),
    };

    this.recorridoDetalleService.obtenerDataToExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      console.log(registros);
      if (respuesta) this.fileDownloadService.VerifyAndDownload(registros[0].rutaArchivo);
    });
  }

  eliminarCamion(cam: any) {
    const title = 'Eliminar';
    const message = '¿Está seguro de eliminar registro?';

    this.modalConfirm.showWithInlineConfig(title, message, () => {
      const _recorrido = _.cloneDeep(cam);
      delete _recorrido.__typename;
      const inputParams = {
        entidad: {
          chofer_rut: cam.chofer_rut,
          codigo: cam.recorrido_codigo,
          camion_patente: cam.patente,
          sucursal_codigo: this.sucursalCodigo,
          rut_empresa: this.rutEmpresa,
          activo: false,
          //unidad_negocio: this.formRuta.get('negocio').value
        },
      };
      this.recorridoService.eliminar(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        this.showSuccess('Operación realizada');
        this.buscarRecorridos();
      });
      // setTimeout(() => this.buscarPorFiltros(), 1000);
    });
  }

  onCamionAsignado() {
    this.buscarPorFiltros();
    this.obtenerResumenDocumentos();
    this.ObtenerCamiones(this.formFiltrosDocumentos.get('filtroFechaDesde').value, this.formFiltrosDocumentos.get('filtroFechaHasta').value, '1');
    // Limpiar el polígono actual si existe
    if (this.polygon) {
      this.polygon.setMap(null);
      this.polygon = null;
    }
    // Limpiar las localizaciones
    document.getElementById('info').innerHTML = '';
    // Reactivar la herramienta de trazo después de un breve delay
    setTimeout(() => {
      if (this.drawingManager && this.globalMap) {
        this.drawingManager.setMap(this.globalMap);
        this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
      }
    }, 100);
  }

  onCamionAutomaticaAsignado() {
    this.buscarPorFiltros();
    this.obtenerResumenDocumentos();
    this.ObtenerCamiones(this.formFiltrosDocumentos.get('filtroFechaDesde').value, this.formFiltrosDocumentos.get('filtroFechaHasta').value, '1');
    // Limpiar el polígono actual si existe
    if (this.polygon) {
      this.polygon.setMap(null);
      this.polygon = null;
    }
    // Limpiar las localizaciones
    document.getElementById('info').innerHTML = '';
    // Reactivar la herramienta de trazo después de un breve delay
    setTimeout(() => {
      if (this.drawingManager && this.globalMap) {
        this.drawingManager.setMap(this.globalMap);
        this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
      }
    }, 100);
  }

  onCargarRuta() {
    const estado = this.formFiltrosDocumentos.get('estadofiltroDetalleRecorrido').value;
    const fecha = this.formFiltrosDocumentos.get('fechafiltroDetalleRecorrido').value;
    const fechaHastaDetalle = this.formFiltrosDocumentos.get('fechafiltroDetalleRecorridoHasta').value;
    this.ObtenerCamiones(fecha, fechaHastaDetalle, estado);
  }

  sumaCajas(): number {
    const sumaCajas = this.listadoDetalleCamionChofer.reduce((total, obj) => {
      return total + obj.cajas;
    }, 0);
    return sumaCajas;
  }

  sumaVolumen(): number {
    const sumaVolumen = this.listadoDetalleCamionChofer.reduce((total, obj) => {
      return total + obj.volumen;
    }, 0);
    return sumaVolumen;
  }

  sumaDocumentos(): number {
    const sumaDocumentos = this.listadoDetalleCamionChofer.length;
    return sumaDocumentos;
  }

  sumaMonto(): number {
    const sumaMonto = this.listadoDetalleCamionChofer.reduce((total, obj) => {
      return total + obj.total_documentos;
    }, 0);
    return sumaMonto;
  }

  showInfo(mensaje) {
    const options = { opacity: 1 };
    this.toastService.info(mensaje, 'Mensaje Información!', options);
  }

  showSuccess(mensaje) {
    const options = { opacity: 1 };
    this.toastService.success(mensaje, 'Operacion Existosa!', options);
  }

  showError(mensaje) {
    const options = { opacity: 1 };
    this.toastService.error(mensaje, 'Mensaje Error!', options);
  }

  getPrioridadValue(prioridad: any): number {
    // Asegurar que la prioridad sea un número válido, si no, usar 0
    if (prioridad === null || prioridad === undefined || isNaN(prioridad) || prioridad === '') {
      return 0;
    }
    return Math.max(0, Math.min(10, Math.round(prioridad)));
  }

  /**
   * Ordena los documentos por prioridad y distancia
   * Prioridad 1 = más prioritario, Prioridad 0 = menos prioritario (va al final)
   * Dentro de cada grupo de prioridad, ordena por proximidad geográfica
   */
  ordenarPorPrioridad(documentos: any[]): any[] {
    if (!documentos || documentos.length === 0) {
      return [];
    }

    console.log('=== INICIO ORDENAMIENTO POR PRIORIDAD ===');

    // Crear una copia del array para no modificar el original
    const documentosConPrioridad = documentos.map(doc => {
      const prioridadOriginal = doc.prioridad;
      const prioridadNormalizada = this.getPrioridadValue(doc.prioridad);
      console.log(`Doc: ${doc.direccion_completa} - Prioridad original: ${prioridadOriginal} - Prioridad normalizada: ${prioridadNormalizada}`);
      return {
        ...doc,
        prioridad: prioridadNormalizada
      };
    });

    // Agrupar por prioridad
    const grupos = new Map<number, any[]>();

    documentosConPrioridad.forEach(doc => {
      const prioridad = doc.prioridad;
      if (!grupos.has(prioridad)) {
        grupos.set(prioridad, []);
      }
      grupos.get(prioridad)!.push(doc);
    });

    // Ordenar cada grupo por distancia (usando latitud y longitud como referencia)
    grupos.forEach((grupo, prioridad) => {
      grupo.sort((a, b) => {
        // Ordenar por coordenadas para mantener consistencia geográfica
        // Primero por latitud, luego por longitud
        const latDiff = parseFloat(a.latitud) - parseFloat(b.latitud);
        if (Math.abs(latDiff) > 0.001) { // Diferencia significativa en latitud
          return latDiff;
        }
        // Si las latitudes son muy similares, ordenar por longitud
        return parseFloat(a.longitud) - parseFloat(b.longitud);
      });
    });

    // Obtener las prioridades ordenadas: 1, 2, 3, ..., 0 (0 va al final)
    const prioridadesOrdenadas = Array.from(grupos.keys()).sort((a, b) => {
      // Prioridad 0 va al final
      if (a === 0 && b !== 0) return 1;
      if (b === 0 && a !== 0) return -1;
      if (a === 0 && b === 0) return 0;

      // Para prioridades 1-10, menor número = más prioritario
      return a - b;
    });

    // Concatenar todos los grupos en el orden correcto
    const resultado: any[] = [];
    prioridadesOrdenadas.forEach(prioridad => {
      const grupo = grupos.get(prioridad);
      if (grupo) {
        resultado.push(...grupo);
      }
    });




    console.log('=== GRUPOS CREADOS ===');
    Array.from(grupos.entries()).forEach(([prioridad, docs]) => {
      console.log(`Prioridad ${prioridad}: ${docs.length} documentos`);
      docs.forEach(doc => console.log(`  - ${doc.direccion_completa}`));
    });

    console.log('=== PRIORIDADES ORDENADAS ===', prioridadesOrdenadas);

    console.log('=== RESULTADO FINAL ===');
    resultado.forEach((doc, index) => {
      console.log(`${index + 1}. ${doc.direccion_completa} - Prioridad: ${doc.prioridad}`);
    });

    this.log('DOCUMENTOS ORDENADOS POR PRIORIDAD', {
      original: documentos.length,
      ordenado: resultado.length,
      prioridades: prioridadesOrdenadas,
      grupos: Array.from(grupos.entries()).map(([p, docs]) => ({ prioridad: p, cantidad: docs.length }))
    });

    return resultado;
  }

  ObtenerDataToPdf() {
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 7,
        categoria_modulo_codigo: 2,
        environment_functions: ENVIRONMENT_FUNCTIONS,
        rut_empresa: this.rutEmpresa,
        rut_usuario: this.rutUsuario,
        sucursal_codigo: this.sucursalCodigo,
        esDetalleRecorrido: false,
        listaRecorridos: this.listadoCamionChofer.filter((x) => x.seleccion).map((x) => ({
          recorrido_codigo: x.recorrido_codigo,
          total_facturas: x.total_facturas,
          total_documentos: x.total_documentos,
        })),
      }
    }

    console.log(inputParams);

    this.loadingPdf = true;
    this.messageLoading = 'Generando los PDFs... Una vez generados se mostrarán en las notificaciones';
    this.sendMessage(inputParams);
  }

  existePDFs(): boolean {
    return this.listadoCamionChofer.some(cam => cam.codigo_estado != 4 && cam.total_documentos > 0);
  }
  permiteObtenerPDF(): boolean {
    return this.listadoCamionChofer.some(cam => cam.seleccion === true);
  }

  onPrioridadChange(prioridad: number, detCam: any) {
    console.log('Prioridad cambiada:', prioridad, 'para documento:', detCam.numero_documento);

    // Asegurar que la prioridad sea un número válido entre 0 y 10
    if (prioridad === null || prioridad === undefined || isNaN(prioridad)) {
      prioridad = 0;
    }

    prioridad = Math.max(0, Math.min(10, Math.round(prioridad)));

    // Actualizar la prioridad en el objeto
    detCam.prioridad = prioridad;

    // También actualizar en el listado completo si existe
    if (this.listadoDetalleCamionChoferAll) {
      const itemCompleto = this.listadoDetalleCamionChoferAll.find(item =>
        item.numero_documento === detCam.numero_documento
      );
      if (itemCompleto) {
        itemCompleto.prioridad = prioridad;
      }
    }
  }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  // Reactiva la herramienta de trazo de polígono
  restaurarEstadoMapaYTrazo() {
    if (this.drawingManager) {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
    }
  }
}
